<template>
    <div :id="removeId" class="session-item" v-if="visible">
      <div class="row mt-2" :class="cssClass">
        <div v-if="hasTimeslots" class="timeslot-label col-4 col-sm-0 mb-2">
          <h3 class="timeslot-label" v-html="item.timeslotLabel"></h3>
        </div>
        <div class="col-12 col-sm-10" style="margin-left: -0.7em;">
            <SessionEditLink v-if="apiStore.isAdmin" cssClass="session-edit" :session="item" />

            <!-- Collapse/expand button -->
            <div class="collapse-btn-parent">
                <a href="#" v-if="item.is_published" class="collapse-ctrl-btn" data-bs-toggle="collapse"
                    :data-bs-target="collapseTarget" :aria-expanded="ariaExpandedValue" :aria-controls="collapseId" :aria-label="collapseButtonLabel"
                    @click.prevent="toggleLabel">
                    <vue-feather :type="collapseButtonFeatherType" class="inline-icon"></vue-feather>
                </a>
            </div>
            <div class="session-container mb-1 spacing-block">
                <div class="spacing-block">
                    <h4 class="spacing-block"><SessionTitle :session="item" /></h4>

                    <!-- Badges -->
                    <span v-if="formatBadgeFeatherType">
                        <span :class="formatBadgeClass">
                            <span class="badge-label">{{ formatBadgeText }}&nbsp;</span>
                            <vue-feather class="badge-icon" :type="formatBadgeFeatherType"></vue-feather>
                        </span>&nbsp;
                    </span>
                    <span v-if="item.mandatory && false == hasHappened">
                        <span class="badge badge-phoenix fs--2 badge-phoenix-info">
                            <span class="badge-label">Required&nbsp;</span>
                            <vue-feather class="badge-icon" type="check"></vue-feather>
                        </span>&nbsp;
                    </span>
                    <span v-if="item.invitation_only && false == hasHappened">
                        <span class="badge badge-phoenix fs--2 badge-phoenix-success">
                            <span class="badge-label">Invited&nbsp;</span>
                            <vue-feather class="badge-icon" type="user-check"></vue-feather>
                        </span>&nbsp;
                    </span>

                    <SessionButton v-if="showSessionButton && item.is_published && apiStore.oid && false == item.mandatory && false == hasHappened"
                        :isRegistered="item.attending" :sessionId="item.id" ref="sessionButton"
                        @session-added="sessionAddedHandler" @session-removed="sessionRemovedHandler" />
                    <SessionTimeConflict :conflicts="item.conflictingSessions"></SessionTimeConflict>


                </div>

                <p class="session-description"><SessionPresenters :session="item" @presenterIdChanged="presenterIdChangedHandler" /></p>
                <p v-if="item.room && apiStore.oid && showRoomCollapsed && showRoom">
                    <span class="fas fa-location-dot pe-2"></span>
                    <span v-if="showVenueName">{{ item.room.venue.name }}: </span>
                    {{ item.room.name }}
                </p>

                <!-- Collapsible area -->
                <div :id="collapseId" class="collapse session-description">
                    <p v-if="item.graphic"><img :src="item.graphic.uri" alt="" /></p>
                    <p v-if="item.room && apiStore.oid && false == showRoomCollapsed && showRoom">
                        <span class="fas fa-location-dot pe-2"></span>
                        <span v-if="showVenueName">{{ item.room.venue.name }}: </span>
                        {{ item.room.name }}
                    </p>

                    <div v-if="item.description" class="session-description" v-html="item.description"></div>

                    <p class="mb-3" v-if="'' != contactsString">
                        Content contact:<br><span v-html="contactsString"></span>
                    </p>
                    <div class="facilitators">
                        <p v-if="item.facilitators.length && showParticipants">
                            <SessionParticipants participantType="facilitators" :session="item" />
                        </p>
                        <p v-if="item.tech_facilitators.length && showParticipants">
                            <SessionParticipants participantType="tech_facilitators" :session="item" />
                        </p>
                        <p v-if="item.captioners.length && showParticipants">
                            <SessionParticipants participantType="captioners" :session="item" />
                        </p>
                        <p v-if="item.translators.length && showParticipants">
                            <SessionParticipants participantType="translators" :session="item" />
                        </p>
                    </div>

                    <!-- Teleconferencing information -->
                    <div v-if="(hasUrls && apiStore.oid && apiStore.isPaidForCurrentEvent && showMaterials) || apiStore.isStaff">
                        <p><span class="fas fa-video pe-2"></span>Online participation</p>
                        <a :href="item.stream_url" v-if="item.stream_url" target="_blank">View session livestream</a>
                        <div v-html="item.teleconferencing_information" v-if="item.teleconferencing_information"></div>
                        <div v-if="showZoomHostKey" class="h5 mb-2">
                            <a target="_blank" href="https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0067063">
                            Zoom host key</a>: {{ item.zoom_account.host_key }}</div>
                    </div>

                    <!-- Materials and recording link -->
                    <div v-if="showMaterial">
                      <p><span class="fas fa-file-arrow-down pe-2"></span>Session materials <span v-if="this.showMaterialControls"><MaterialButton :sessionId="this.item.id"></MaterialButton></span></p>
                        <p v-for="material in materials" :key="material.id">
                          <a class="materials-list" :href="material.uri" target="_blank">{{ material.displayName }}</a>
                          <span v-if="this.showMaterialControls">
                              <a href="#" @click="removeMaterialHandler(item.id, material.id)">
                                  <i class="fa fa-solid fa-trash fa-xs remove-material ps-2" aria-hidden="true"></i></a></span>
                        </p><br>
                        <a :href="item.recording_url" v-if="item.recording_url" target="_blank">View session recording</a>
                    </div>


                    <!-- Presentation Materials -->
                    <div v-if="this.showPresentationMaterial">
                      <p>
                        <span class="fas fa-file-arrow-down pe-2"></span>
                        Presentation materials <span v-if="this.showMaterialControls">
                        <PresentationMaterialButton :sessionId="this.item.id"></PresentationMaterialButton>
                        </span>
                      </p>
                      <p v-for="presentationMaterial in presentationMaterials" :key="presentationMaterial.id">
                        <a class="materials-list" :href="presentationMaterial.uri">{{ presentationMaterial.displayName }}</a><span v-if="this.showMaterialControls"><a href="#" @click="removeMaterialHandler(item.id, presentationMaterial.id)"><i class="fa fa-solid fa-trash fa-xs remove-material ps-2" aria-hidden="true"></i></a></span>
                      </p>
                    </div>


                    <!-- Instructional information -->
                    <div v-if="item.instructional_information && apiStore.oid && apiStore.isPaidForCurrentEvent" v-html="item.instructional_information"></div>

                    <!-- Admin notes -->
                    <div v-if="apiStore.isStaff && null != item.admin_notes && '' != item.admin_notes">
                        <hr>
                        <p><strong>Admin Notes:</strong></p>
                        <div v-html="item.admin_notes"></div>
                    </div>

                    <!-- Presenter notes -->
                    <div v-if="showPresenterNotes">
                        <hr>
                        <p><strong>Presenter Notes:</strong></p>
                        <div v-html="item.presenter_notes"></div>
                    </div>
                    <div v-if=" isMySchedule && item.attending && showAssessment">
                    <!-- div v-if="isMySchedule" -->
                        <span v-if="false == item.non_instructional">&nbsp;<input type="checkbox"
                        ref="attendedCheckbox" />&nbsp;I attended</span>
                        <p><strong v-if="false == item.non_instructional && assessment.length">Assessment:</strong></p>
                        <div v-for="(assessment, index) in this.assessment" :key="index">
                            <div class="me-2 ">{{ assessment.question }}</div>
                            <div class="me-2"><textarea rows="2" v-if="assessment.answer" :class="['assessment-question', `assessment-question-${item.id}`]" type="text" :name="assessment.question" :value="assessment.answer"/></div>
                            <div class="me-2"><textarea rows="2" v-if="!assessment.answer" :class="['assessment-question', `assessment-question-${item.id}`]" type="text" :name="assessment.question" value=""/></div>
                        </div>
                        <div v-if="assessment.length" class="btn btn-outline-primary" @click="assessmentHandler($event, item.id)">Save</div>
                    </div>
                </div>
                <!-- End collapsible area -->

            </div>
        </div>
      </div>
    </div>
</template>

<script>
/* eslint-env jquery */
import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import SessionButton from '@/components/SessionButton'
import SessionEditLink from '@/components/SessionEditLink'
import SessionParticipants from '@/components/SessionParticipants'
import SessionPresenters from '@/components/SessionPresenters'
import SessionTimeConflict from "@/components/SessionTimeConflict"
import SessionTitle from '@/components/SessionTitle'
import {useApiStore} from '@/store/api'
import {callApi} from '@/shared/ApiHelper'
import {telephoneNumberFormat} from '@/shared/Utilities'
import {useEventsStore} from "@/store/events"
import VueFeather from 'vue-feather'
import MaterialButton from "@/components/MaterialButton.vue";
import PresentationMaterialButton from "@/components/PresentationMaterialButton.vue"
import { useRoute } from 'vue-router'


export default {
    name: 'EventSessionListItem',

    components: {
        MaterialButton,
        SessionButton,
        SessionEditLink,
        SessionParticipants,
        SessionPresenters,
        SessionTimeConflict,
        SessionTitle,
        VueFeather,
        PresentationMaterialButton,
    },

    computed: {
        collapseTarget() {
            return '#' + this.collapseId
        },
        removeTarget() {
            return '#' + this.removeId
        },
    },

    async created() {
        if (this.item.isEndOfTimeslot) {
            this.cssClass += ' mb-3 with-separator'
        }
        dayjs.extend(utc)
        dayjs.extend(timezone)
        const now = dayjs().tz(this.item.timeslot.date.timezone) // Do all time-based display calculations in event's zone
        const end_time = dayjs(this.item.timeslot.date.calendar_date + ' ' + this.item.timeslot.end_time)
        const start_time = dayjs(this.item.timeslot.date.calendar_date + ' ' + this.item.timeslot.start_time)
        this.hasHappened = 0 > end_time.diff(now)
        this.hasBegun = 15 < now.diff(start_time, 'minute')
        if (this.item.teleconferencing_information || this.item.stream_url) {
            this.hasUrls = true
            // If there is a URL and the current time is no more than 15 minutes prior to the start and not later than the end
            if (this.item.teleconferencing_information || this.item.stream_url) {
                if (this.apiStore.isStaff) {
                    this.isHappening = true
                } else {
                    this.isHappening = (15 > start_time.diff(now, 'minute') && 0 < end_time.diff(now))
                }
            }
        }

        this.materials = []
        this.presentationMaterials = []
        if(this.item.assets && this.item.assets.length > 0){
          this.item.assets.forEach( (file) => {
              if(file.presenter){
              this.presentationMaterials.push(file)
            } else {
              this.materials.push(file)
            }
          })
        }

        if (this.item.recording_url || (this.materials && 0 < this.materials.length) ||
            this.attendeeIsIn(this.item.presenters, this.apiStore.currentAttendee)) {
            this.hasMaterials = true
        }
        if (this.materials) {
            for (let i = 0; i < this.materials.length; ++i) {
                const uriPieces = this.materials[i].uri.split('/')
                const namePieces = uriPieces[uriPieces.length - 1].split('?')
                this.materials[i].displayName = namePieces[0]
                this.materials[i].uri = this.materials[i].uri.split('?')[0]
            }
        }
        if (this.presentationMaterials) {
            for (let i = 0; i < this.presentationMaterials.length; ++i) {
                const uriPieces = this.presentationMaterials[i].uri.split('/')
                const namePieces = uriPieces[uriPieces.length - 1].split('?')
                this.presentationMaterials[i].displayName = namePieces[0]
            }
        }


        if ('hybrid' == this.item.event.format && 'hybrid' != this.item.format && null != this.item.format) {
            this.formatBadgeFeatherType = 'virtual' == this.item.format ? 'monitor' : 'user'
            this.formatBadgeClass = 'badge badge-phoenix fs--2 badge-phoenix-' + ('virtual' == this.item.format ? 'secondary' : 'primary')
            this.formatBadgeText = 'virtual' == this.item.format ? 'Online' : 'In person'
        }

        this.showMaterial = (this.hasMaterials && this.showMaterials && this.apiStore.oid && this.apiStore.isPaidForCurrentEvent) ||
            this.apiStore.isStaff || this.attendeeIsIn(this.item.presenters, this.apiStore.currentAttendee)
        this.showMaterialControls = this.attendeeIsIn(this.item.presenters, this.apiStore.currentAttendee) ||
            this.attendeeIsIn(this.item.facilitators, this.apiStore.currentAttendee) ||
            this.attendeeIsIn(this.apiStore.currentEvent.event.admins, this.apiStore.currentAttendee)
        this.showRoom = this.apiStore.isStaff || (this.item.showRoom && this.apiStore.isPaidForCurrentEvent)
        this.showPresentationMaterial = this.attendeeIsIn(this.item.presenters, this.apiStore.currentAttendee) || this.apiStore.isStaff
        if (null != this.item.presenter_notes && '' != this.item.presenter_notes) {
            if (this.apiStore.isStaff) {
                this.showPresenterNotes = true
            } else {
                for (let i = 0; i < this.item.presenters.length; ++i) {
                    if (this.apiStore.currentAttendee.id == this.item.presenters[i].id) {
                        this.showPresenterNotes = true
                        break
                    }
                }
                if (false == this.showPresenterNotes) {
                    for (let i = 0; i < this.item.facilitators.length; ++i) {
                        if (this.apiStore.currentAttendee.id == this.item.faciitators[i].id) {
                            this.showPresenterNotes = true
                            break
                        }
                    }
                }
            }
        }

        this.showParticipants = this.apiStore.isStaff
            || this.attendeeIsIn(this.item.presenters, this.apiStore.currentAttendee)
            || this.attendeeIsIn(this.item.facilitators, this.apiStore.currentAttendee)
            || this.attendeeIsIn(this.item.tech_facilitators, this.apiStore.currentAttendee)
            || this.attendeeIsIn(this.item.captioners, this.apiStore.currentAttendee)
            || this.attendeeIsIn(this.item.translators, this.apiStore.currentAttendee)

        if (null != this.item.showVenueName) {
            this.showVenueName = this.item.showVenueName
        }

        if (this.item.zoom_account && this.item.zoom_account.host_key) {
            for (let i in this.item.presenters) {
                if (this.item.presenters[i].id == this.apiStore.currentAttendee.id) {
                    this.showZoomHostKey = true
                }
            }
            for (let i in this.item.facilitators) {
                if (this.item.facilitators[i].id == this.apiStore.currentAttendee.id) {
                    this.showZoomHostKey = true
                }
            }
            for (let i in this.item.tech_facilitators) {
                if (this.item.tech_facilitators[i].id == this.apiStore.currentAttendee.id) {
                    this.showZoomHostKey = true
                }
            }
        }

        if(this.item.content_contacts){
            for (let i = 0; i < this.item.content_contacts.length; ++i) {
                if ('' != this.contactsString) {
                    this.contactsString += '<br>'
                }
                const formattedTelephoneNumber = telephoneNumberFormat(this.item.content_contacts[i].registration_phone_number)
                this.contactsString += this.item.content_contacts[i].display_name + '&nbsp;&nbsp;' +
                    '<a href="mailto:' + this.item.content_contacts[i].registration_email_address + '">' +
                    this.item.content_contacts[i].registration_email_address + '</a>'
                if (formattedTelephoneNumber) {
                    this.contactsString += '&nbsp;&nbsp;' + formattedTelephoneNumber
                }
            }
        }
        let response = await callApi(this.apiStore.buildUrl('/events/sessionattendees/?session='+this.item.id+'&attendee='+this.apiStore.currentAttendee.id) )
        if (response && 200 <= response.status && 209 >= response.status){
            if(response.data && response.data.length > 0){
                this.assessment = response.data[0]['q_and_a']
            }
        }
    },

    data() {
        return {
            route:  useRoute(),
            apiStore: useApiStore(),
            ariaExpandedValue: 'false',
            assessment:[],
            cssClass: 'item-background',
            collapseButtonFeatherType: 'chevron-down',
            collapseButtonLabel: 'Expand collapsed session details',
            collapseId: 'session' + this.item.id,
            contactsString: '',
            didAttend: false,
            eventsStore: useEventsStore(),
            formatBadgeClass: null,
            formatBadgeFeatherType: null,
            formatBadgeText: '',
            hasBegun: false,
            hasHappened: false,
            hasMaterials: false,
            hasUrls: false,
            isHappening: false,
            materials: [],
            presentationMaterials: [],
            removeId: 'remove' + this.item.id,
            showMaterial: false,
            showParticipants: false,
            showRoom: false,
            showVenueName: false,
            showMaterialControls: false,
            showPresentationMaterial: false,
            showPresenterNotes: false,
            showZoomHostKey: false,
        }
    },

    emits: [
        'presenterIdChanged',
        'sessionAdded',
        'sessionRemoved',
    ],

    methods: {
        adjustCachedSessions(isAttending) {
            // If the cached event includes this session
            if (this.apiStore.currentEvent && this.apiStore.currentEvent.event.id == this.item.event.id) {
                const sessions = this.apiStore.currentEvent.sessions
                for (let i = 0; i < sessions.length; ++i) {
                    if (sessions[i].id == this.item.id) {
                        sessions[i].attending = isAttending
                        break
                    }
                }
            }

            // If the cached presenter includes this session
            let isMatchingPresenter = false
            if (this.apiStore.currentPresenter) {
                for (let i = 0; i < this.item.presenters.length; ++i) {
                    if (this.item.presenters[i].id == this.apiStore.currentPresenter.presenter.id) {
                        isMatchingPresenter = true
                        break
                    }
                }
            }
            if (isMatchingPresenter) {
                const sessions = this.apiStore.currentPresenter.sessions
                for (let i = 0; i < sessions.length; ++i) {
                    if (sessions[i].id == this.item.id) {
                        sessions[i].attending = isAttending
                        break
                    }
                }
            }
        },

        async attendedCheckboxChangedHandler(event) {
            const data = {session_id: this.item.id, attendee_id: this.apiStore.currentAttendee.id, attended: true}
            const apiResponse = await callApi(this.apiStore.buildUrl('/events/sessionattendees/'), 'PATCH', data, true)
            if (apiResponse.data.status) {
                if ('success' == apiResponse.data.status) {
                    const negation = event.srcElement.checked ? '' : 'not '
                    alert('You are marked as ' + negation + 'having attended "' + this.item.name + '"')
                } else {
                    alert('Error updating attendance status: ' + apiResponse.data.message)
                }
            } else {
                alert('Error updating attendance status: ' + JSON.stringify(apiResponse.data))
            }
        },

        attendeeIsIn(participants, attendee) {
            for (let i = 0; i < participants.length; ++i) {
                if (attendee && attendee.id == participants[i].id) {
                    return true
                }
            }
            return false
        },

        presenterIdChangedHandler(value) {
            this.$emit('presenterIdChanged', value)
        },

        async removeMaterialHandler(sessionId, materialId) {
            const endpoint = this.apiStore.buildUrl('/events/assets/' + materialId + '/?a=' + this.apiStore.oid + '&w=file')
            let response = await callApi(endpoint, 'DELETE')
            if (response && 200 <= response.status && 209 >= response.status) {
                this.materials = this.materials.filter((material) => material.id !== materialId)
                this.presentationMaterials = this.presentationMaterials.filter((material) => material.id !== materialId)
                this.apiStore.removeSessionAsset(sessionId, materialId)
                console.log('file removed.')
            } else {
                console.log('This is an undefined state.  Do a hard refresh and see where you are.')
            }
        },

        sessionAddedHandler(value) {
            this.apiStore.mySchedule = null
            this.adjustCachedSessions(true)
            this.$emit('sessionAdded', value)
        },

        async sessionRemovedHandler(value) {
            this.apiStore.mySchedule = null
            if (this.removable) {
                await $(this.removeTarget).addClass('collapse')
                await $(this.removeTarget).addClass('show')
                await $(this.removeTarget).collapse('hide')
                await new Promise(r => setTimeout(r, 1000)) // to give the collapse animation time to run
            }
            this.adjustCachedSessions(false)
            this.$emit('sessionRemoved', value)
        },

        toggleLabel() {
            this.collapseButtonFeatherType = 'chevron-down' == this.collapseButtonFeatherType ? 'chevron-up' : 'chevron-down'
            this.collapseButtonLabel = 'Expand session details' == this.collapseButtonLabel ? 'Collapse session details' : 'Expand session details'
            this.ariaExpandedValue = 'Expand session details' == this.collapseButtonLabel ? 'false' : 'true'
        },

        async assessmentHandler(event, sessionNum) {
            event.stopPropagation()
            event.preventDefault()
            let answers = document.getElementsByClassName("assessment-question-"+sessionNum)

            for(let element of answers){
                // find the question in the assessment object and add/set the answer
                let assessmentObjIndex = this.assessment.findIndex(arrayElement => arrayElement['question'] === element.name)
                if(assessmentObjIndex === -1){
                    continue
                }
                this.assessment[assessmentObjIndex].answer = element.value
            }

            let data = {
                'session_id':this.item.id,
                'attendee_id': this.apiStore.currentAttendee.id,
                'assessment': this.assessment
            }

            const apiResponse = await callApi(this.apiStore.buildUrl('/events/sessionattendees/'), 'PATCH', data, true)

            if (apiResponse.status) {
                if (apiResponse && 200 <= apiResponse.status && 209 >= apiResponse.status){
                    new Notyf({position: {x:'right',y:'top'}}).success("Saved")
                } else {
                    new Notyf({position: {x:'right',y:'top'}}).error("Save error: please try again.")
                }
            }
        },
    },

    async mounted() {
        document.getElementById(this.collapseId)?.classList.add('show')
        this.collapseButtonFeatherType = 'chevron-up'
        this.collapseButtonLabel = 'Collapse expanded session details'
        this.areaExpandedValue = 'true'

        this.eventsStore.$subscribe((mutation, state) => {
            if(state.expandCollapseSessionDescriptionState == 'expanded'){
                this.collapseButtonFeatherType = 'chevron-up'
                this.collapseButtonLabel = 'Collapse expanded session details'
            }

            if(state.expandCollapseSessionDescriptionState == 'collapsed'){
                this.collapseButtonFeatherType = 'chevron-down'
                this.collapseButtonLabel = 'Expand collapsed session details'
            }
        })

        if (this.$refs.attendedCheckbox) {
            const endpoint =  this.apiStore.buildUrl('/events/sessionattendees/?session=' + this.item.id + '&attendee=' + this.apiStore.currentAttendee.id)
            const response = await callApi(endpoint)
            if (response && 200 <= response.status && 209 >= response.status){
                const sessionAttendees = response.data
                if (Array.isArray(sessionAttendees) && 1 == sessionAttendees.length) {
                    this.$refs.attendedCheckbox.checked = sessionAttendees[0].attended
                }
            }
            this.$refs.attendedCheckbox.addEventListener('change', this.attendedCheckboxChangedHandler)
        }
    },

    props: {
        hasTimeslots: {
            type: Boolean,
            default: true,
        },
        item: {
            type: Object,
        },
        removable: {
            type: Boolean,
            default: false,
        },
        schedulable: {
            type: Boolean,
            default: true,
        },
        showMaterials: {
            type: Boolean,
            default: false,
        },
        showRoomCollapsed: {
            type: Boolean,
            default: false,
        },
        showSessionButton: {
            type: Boolean,
            default: true,
        },
        visible: {
            type: Boolean,
            default: true,
        },
        isMySchedule:{
            type: Boolean,
            default: false,
        },
        showAssessment: {
            type: Boolean,
            default: false
        }
    },
}

</script>

<style scoped>

a.materials-list {
    font-weight: normal;
}

.remove-material{
  color: var(--phoenix-danger-600)
}
.add-material {
  color: var(--phoenix-success-600);
}

div.facilitators {
    margin-bottom: 0.5rem;
}

h4 {
    display: inline-block;
    font-size: 100%;
    margin-bottom: 0px;
    margin-right: 0.25rem;
    font-weight: bold;
}

.item-background {
    min-height: 3.7em;
}

p {
    margin-top: 0.01rem;
    margin-bottom: 0.01rem;
}

.session-card {
    background-color: var(--phoenix-navbar-top-bg-color);
    border-color:  var(--phoenix-gray-200);
    border-radius: 0.5rem;
    border-style: solid;
    border-width: 1px;
    display: flex;
    flex-direction: column;
    padding: 0.7rem 0.5rem 0.5rem 0.5rem;
    position: relative;
}

.session-card-body {
    -webkit-box-flex: 1;
    flex: 1 1 auto;
    margin-bottom: -14px;
    padding: 0px;
}

.session-container {
    margin-left: 1.7em;
}

.session-description {
    margin: 0 0 10px;
    color: var(--light-grey);
    font-size: 90%;
}

.session-item {
    height: auto;
}

.session-item.collapsing {
    height: 0;
    transition: height 0.5s ease-in;
}

.spacing-block {
    border: solid transparent 1px;
}

div.timeslot-label {
    float: left;
    width: 14em;
}

.timeslot-label h3 {
    font-size: 0.8rem;
    font-weight: normal;
    line-height: 1rem;
}

@media only screen and (min-width: 450px) {
    div.collapse-btn-parent {
        float: left;
        margin-right: 0.3rem;
        width: 1.5rem;
    }

    div.timeslot-label {
        float: left;
        width: 6.2em;
    }
}
.assessment-question{
    width:100%;
    border-color:  var(--phoenix-gray-200);
    border-radius: 0.5rem;
}
</style>